const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const sort_by = urlParams.get('sort_by')

if (sort_by) {
    const url = location.protocol + "//" + location.host + location.pathname + '?sort_by=' + sort_by;
    document.querySelector('.js-sort').value = url;
}

jQuery(document).ready(function () {
    setLoadMore(jQuery('.js-load-more'));
});

function setLoadMore(el) {
    el.click(function (e) {
        e.preventDefault();
        let url = jQuery(this).attr('href');
        jQuery(this).hide();
        loadMore(url);
    })
}

function loadMore(url) {

    $.ajax({
        type: 'GET',
        url: url,
        success: function(data) {
            var filteredData = $(data).find('.js-products');
            var newMore = $(data).find(".js-more");

            filteredData.insertBefore( $("#product-list-foot") );
            newMore.insertBefore($("#product-list-foot"));            
            
            setLoadMore(newMore.find('.js-load-more'))
        },
        dataType: "html"
    });
}

function switchVariant(event) {
  event.preventDefault();
  const productSwatches = event.target.closest(".collection__swatches");
  const swatches = productSwatches.querySelectorAll('.product-swatch');
  const selectedImageSrc = event.target.getAttribute("data-image-src");
  const selectedUrl = event.target.getAttribute("data-variant-url");
  let productItem = event.target.closest(".product-item");
  let productImage =  productItem.querySelectorAll('.product-image');
  swatches.forEach(swatch => {
    swatch.classList.remove('selected-swatch');
  });
  event.target.classList.add('selected-swatch');
  productItem.href = selectedUrl;
  productImage[0].src = selectedImageSrc;
}